var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_541_4851)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9914 0.444336C4.74052 0.444336 0.444336 4.74434 0.444336 9.99989C0.444336 15.2554 4.74052 19.5554 9.9914 19.5554C15.2423 19.5554 19.5385 15.2554 19.5385 9.99989C19.5385 4.74434 15.29 0.444336 9.9914 0.444336ZM14.3831 14.2521C14.1921 14.5388 13.858 14.6343 13.5716 14.4432C11.328 13.0577 8.51161 12.771 5.17013 13.5354C4.83599 13.631 4.54958 13.3921 4.4541 13.1054C4.35863 12.771 4.59731 12.4843 4.88372 12.3888C8.51161 11.5766 11.6621 11.911 14.1444 13.4399C14.4785 13.5832 14.5263 13.9654 14.3831 14.2521ZM15.5287 11.6243C15.29 11.9588 14.8604 12.1021 14.5263 11.8632C11.9486 10.2866 8.03426 9.80878 5.02693 10.7643C4.64505 10.8599 4.21543 10.6688 4.11996 10.2866C4.02449 9.90434 4.21543 9.47434 4.59731 9.37878C8.08199 8.32767 12.3782 8.85322 15.3378 10.6688C15.6242 10.8121 15.7674 11.2899 15.5287 11.6243ZM15.6242 8.94878C12.5691 7.13322 7.46143 6.94211 4.54958 7.84989C4.07222 7.99322 3.59487 7.70656 3.45166 7.27656C3.30846 6.79878 3.59487 6.321 4.02449 6.17767C7.4137 5.17434 12.9987 5.36545 16.5311 7.46767C16.9608 7.70656 17.104 8.27989 16.8653 8.70989C16.6266 9.04434 16.0538 9.18767 15.6242 8.94878Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_541_4851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.87721fab5be9942c13d0ef6ac7107cc7.svg";
export { ForwardRef as ReactComponent };